<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.volumeComplaints.title"
                        [body]="{
                            value: kpi.volumeComplaints,
                            precision: texts.volumeComplaints.precision,
                        }"
                        [badge]="{
                            value: kpi.volumeComplaintsEvolution,
                            suffix: texts.volumeComplaints.badgeSuffix,
                            precision: texts.volumeComplaints.badgePrecision,
                            style: kpi.volumeComplaintsEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.volumeComplaints.descriptionTitle"
                        [descriptionContent]="texts.volumeComplaints.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'volumeComplaints')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.responseComplaintsRate.title"
                        [body]="{
                            value: kpi.responseComplaintsRate,
                            precision: texts.responseComplaintsRate.precision,
                            suffix: texts.responseComplaintsRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.responseComplaintsRateEvolution,
                            suffix: texts.responseComplaintsRate.badgeSuffix,
                            precision: texts.responseComplaintsRate.badgePrecision,
                            style: kpi.responseComplaintsRateEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'responseComplaintsRate')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="evolComplaintsEnedis"
                [title]="texts.evolComplaintsEnedisChart.title"
                [error]="complChartError"
                [isLoading]="!complChartData()[0].organizationId"
                [series]="complChartSeries"
                [dataLabels]="complDataLabels"
                [stacked]="true"
                [yaxis]="complYaxis"
                [xaxisCategories]="complXaxisCategories"
                [precision]="texts.evolComplaintsEnedisChart.precision"
                [xaxisTitle]="texts.evolComplaintsEnedisChart.xaxisTitle"
                [legend]="complLegend"
                [customTooltip]="evolComplaintsCustomTooltip"
                class="h-100">
            </chart-card>
            <div class="row">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="evolRateResponseComplaints"
                        [title]="texts.evolRateResponseComplaintsChart.title"
                        [error]="respChartError"
                        [isLoading]="!respChartData()[0].organizationId"
                        [series]="respChartSeries"
                        [dataLabels]="respDataLabels"
                        [stacked]="true"
                        [yaxis]="respYaxis"
                        [xaxisCategories]="respXaxisCategories"
                        [precision]="texts.evolRateResponseComplaintsChart.precision"
                        [xaxisTitle]="texts.evolRateResponseComplaintsChart.xaxisTitle"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="evolRateComplaintsUserChart"
                        [title]="texts.evolRateComplaintsUserChart.title"
                        [error]="userChartError"
                        [isLoading]="!userChartData()[0].organizationId"
                        [series]="userChartSeries"
                        [dataLabels]="userDataLabels"
                        [stacked]="true"
                        [yaxis]="userYaxis"
                        [xaxisCategories]="userXaxisCategories"
                        [precision]="texts.evolRateComplaintsUserChart.precision"
                        [xaxisTitle]="texts.evolRateComplaintsUserChart.xaxisTitle"
                        class="h-100">
                    </chart-card>
                </div>
            </div>

            <chart-card
                id="rateClaimsComparison"
                [title]="texts.rateClaimsComparisonChart.title"
                [descriptionTitle]="texts.rateClaimsComparisonChart.descriptionTitle"
                [descriptionContent]="texts.rateClaimsComparisonChart.descriptionContent"
                [error]="rateClaimsComparisonChartError"
                [isLoading]="!rateClaimsComparisonChartDataSignal()[0].organizationId"
                [type]="'rangeBar'"
                [dataLabels]="comparisonDataLabels"
                [series]="rateClaimsComparisonChartSeries"
                [yaxis]="rateClaimsComparisonChartYaxis"
                [plotOptions]="comparisonPlotOptions"
                [customTooltip]="rateClaimsComparisonCustomTooltip"
                cardClass="h-100">
            </chart-card>

            <geo-map-card
                [title]="texts.enedisClaimRateMap.title"
                [descriptionContent]="texts.enedisClaimRateMap.descriptionContent"
                [descriptionTitle]="texts.enedisClaimRateMap.descriptionTitle"
                [geometries]="geometries()"
                [isLoading]="!geometries()[0].organizationId"
                [error]="!!geometries()[0].error"
                [getStyle]="getMapStyle"
                [legendConfig]="legendConfig"
                [mapId]="'enedisClaimRateMap'"
                [getTooltip]="getTooltip"></geo-map-card>
        </div>
    </div>
</div>
